export const environment = {
  production: false,
  environmentName: 'staging',
  apiUrl: 'https://staging-api.dynamicmanaging.com/',
};
